<script>
export default {
  props: {
    callback: {
      type: Function,
      required: true,
    },
  },
  methods: {
    handleClick (e) {
      if (!this.$el.contains(e.target)) {
        this.callback(e);
      }
    },
  },
  mounted () {
    document.addEventListener('click', this.handleClick, true);
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClick, true);
  },
  render () {
    return this.$scopedSlots.default();
  },
};
</script>
